import React from "react";
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useModals, CLOSE_GENERAL } from "../context/modals";
import ProfileFormContainer from "./ProfileForm";
import DropboxIntegrationContainer from "./DropboxIntegration";
import { useTranslation } from "react-i18next";



function GeneralConfiguration ({isOpen, onClose}) {
    const { t } = useTranslation('common');

    if (!isOpen) {
        return null
    }

    return (
        ReactDOM.createPortal(
        <div id="general-configuration" className="bg-light position-fixed">
            <div className="bg-grey-2 py-3 px-4">
                <div className="row">
                    <div className="col-md-8 col-7 py-3">
                        <h4 className="mb-0">{t('generalConfiguration')}</h4>  
                    </div>
                    <div className="col-md-4 col-5">
                        <div id="closeConfig" className="btn btn-primary btn-sm pointer ml-2 float-right" onClick={onClose}>
                            {t('actions.close')}
                            <FontAwesomeIcon icon={"times-circle"} className="ml-2" inverse />
                        </div>
                    </div>
                </div>
            </div>
            <div className="main-container">

            
                <ProfileFormContainer />
                <div className="border-bottom" />
                <div className="p-4">
                    <h5 className="fonts-weight-bold mb-4">{t('storage')}</h5>
                    <DropboxIntegrationContainer />
                </div>
            </div>
        </div>, document.body)

    );
}

function GeneralConfigurationContainer() {
    const [modalsState, dispatch] = useModals();

    const handleClose = () => dispatch({type: CLOSE_GENERAL})

    return <GeneralConfiguration 
                isOpen={modalsState.general} 
                onClose={handleClose}
            />
}


export default GeneralConfigurationContainer;